import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/two-factor/disable")({
  component: () => <Navigate to="/" replace />,
});
